// export const API_BASE = "http://localhost:8080/api";
export const API_BASE = "https://splitwisewebapp-production.up.railway.app/api";